import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eInventoryRouteNames } from '../enums/route-names';

export const LEGAL_DOCUMENTS_LEGAL_DOCUMENT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inventory/legal-documents',
        parentName: eInventoryRouteNames.Inventory,
        name: 'Inventory::Menu:LegalDocuments',
        layout: eLayoutType.application,
        requiredPolicy: 'Inventory.LegalDocuments',
      },
    ]);
  };
}
